import React from 'react'
import { withStyles, Tabs, Theme, createStyles } from '@material-ui/core'

interface StyledTabsProps {
  value: string
  onChange: (event: React.ChangeEvent<{}>, newValue: number) => void
}

const NavigationTabs = withStyles((theme: Theme) =>
  createStyles({
    indicator: {
      display: 'flex',
      justifyContent: 'center',

      '& > span': {
        width: '100%',
        backgroundColor: 'white',
      },
    },
  })
)((props: StyledTabsProps) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />)

export default NavigationTabs
